import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { FeaturesGrid } from '../components/FeaturesGrid';
import { Testimonials } from '../Testimonials';
import { ProgramIncludes } from '../components/ProgramIncludes';
import { VIPUpsellBox } from '../components/VIPUpsellBox';
import { StickyBottomBar } from '../components/StickyBottomBar';
import { PricingSection } from '../PricingSection';
import { Protocolo7dias } from '../Protocolo7dias';
export function LandingPage() {
  useEffect(() => {
    if ((window as any).fbq) return;
    // Inject fbevents.js script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    script.onload = () => {
      const fbq = (window as any).fbq;
      if (fbq) {
        fbq('init', '916427654395377');
        fbq('track', 'PageView');
      }
    };
    // Bootstrap fbq queue so calls before script loads are buffered
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    (window as any).fbq = n;
    (window as any)._fbq = n;
    // Fire immediately (queue will flush once script loads)
    n('init', '916427654395377');
    n('track', 'PageView');
    // Noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=916427654395377&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      if (document.head.contains(noscript)) document.head.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-[#FFFDD0] font-body text-gray-900 selection:bg-[#FADADD] selection:text-gray-900" data-id="element-192">
      {/* Header Limpio (Sin distracciones ni menús) */}
      <header className="absolute top-0 left-0 right-0 z-50 py-6 px-6 md:px-12" data-id="element-193">
        <nav className="max-w-7xl mx-auto flex justify-center items-center" data-id="element-194">
          <div className="text-2xl font-heading font-bold tracking-tighter uppercase" data-id="element-195">
            FaceLift<span className="text-[#D4AF37]" data-id="element-196">.</span>
          </div>
        </nav>
      </header>

      {/* Contenido Principal */}
      <main data-id="element-197">
        <HeroSection data-id="element-198" />
        <FeaturesGrid data-id="element-199" />
        <Testimonials data-id="element-200" />
        <ProgramIncludes data-id="element-201" />
        <Protocolo7dias data-id="element-202" />
        <PricingSection data-id="element-203" />
      </main>

      {/* Pie de Página Premium */}
      <footer className="bg-[#1a1a1a] text-white py-12 px-6 border-t border-gray-800 pb-24 md:pb-12" data-id="element-204">
        <div className="max-w-7xl mx-auto text-center" data-id="element-205">
          <div className="text-2xl font-heading font-bold tracking-tighter uppercase mb-6" data-id="element-206">
            FaceLift<span className="text-[#D4AF37]" data-id="element-207">.</span>
          </div>
          <p className="text-gray-400 text-sm mb-8 max-w-md mx-auto font-light leading-relaxed" data-id="element-208">
            Alternativa natural y científicamente comprobada para el
            rejuvenecimiento facial. Esculpe, desinflama y tonifica tu rostro
            desde la comodidad de tu hogar.
          </p>
          <div className="text-xs text-gray-500 uppercase tracking-widest flex flex-col items-center gap-3" data-id="element-209">
            <span data-id="element-210">
              © 2026 FaceLift Natural. Todos los derechos reservados.
            </span>
            <span className="lowercase text-gray-600" data-id="element-211">
              soporte@[TU-DOMINIO].com
            </span>
          </div>
        </div>
      </footer>

      {/* Barra de Compra Flotante */}
      <StickyBottomBar data-id="element-212" />
    </div>;
}